import { render, staticRenderFns } from "./OrticDataHistory.vue?vue&type=template&id=4dcf8718&scoped=true&"
import script from "./OrticDataHistory.vue?vue&type=script&lang=js&"
export * from "./OrticDataHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrticDataHistory.vue?vue&type=style&index=0&id=4dcf8718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf8718",
  null
  
)

export default component.exports